var map = {
	"./Bear.svg": 7353,
	"./Bull.svg": 8880,
	"./Bull2.svg": 7650,
	"./Caribou.svg": 7062,
	"./Cat.svg": 9389,
	"./Cow.svg": 2264,
	"./Croc.svg": 2926,
	"./Deer.svg": 5911,
	"./Dino.svg": 8767,
	"./Dog.svg": 331,
	"./Dragon.svg": 5330,
	"./Dragon2.svg": 5292,
	"./Elk.svg": 4911,
	"./Equine.svg": 7296,
	"./Falcon.svg": 1616,
	"./Fox.svg": 7378,
	"./Husky.svg": 4501,
	"./Ibex.svg": 3245,
	"./Kangaroo.svg": 5457,
	"./Leopard.svg": 6006,
	"./Lion.svg": 5621,
	"./Moose.svg": 4634,
	"./Paw.svg": 8285,
	"./Puma.svg": 3104,
	"./Rabbit.svg": 3735,
	"./Raccoon.svg": 5710,
	"./Ram.svg": 1161,
	"./Rat.svg": 7136,
	"./Raven.svg": 9935,
	"./Seal.svg": 1064,
	"./Shark.svg": 7110,
	"./Skunk.svg": 4871,
	"./Snake.svg": 3617,
	"./Velociraptor.svg": 8875,
	"./Wolf.svg": 6235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 449;